import React, {
  useCallback,
  useContext,
  useEffect,
  useState,
} from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Card, SnackBarProvider } from '@usealloy/component-library';

import { UserContext } from '~/dashboard/context';
import { shouldRenderCard } from '~/entities/evaluations/utils/shouldRenderCard';
import TransactionHistory from '~/entities/evaluations/transaction/history/TransactionHistory';

import { DEFAULT_COLUMNS } from '~/entities/evaluations/transaction/history/constants';

const CollapsiboxWrapper = styled.div`
  display: grid;
`;
const CollapsiboxTransactionHistory = styled(Card)`
  overflow: auto;
`;

const TransactionHistoryCollapsiboxPropTypes = {
  agent: PropTypes.object,
  entity: PropTypes.object.isRequired,
  loading: PropTypes.bool,
  header: PropTypes.string,
  view: PropTypes.string,
  canSendWebhookFromPage: PropTypes.bool,
  caseToken: PropTypes.string,
  canUpdateStatus: PropTypes.bool,
};
const TransactionHistoryCollapsiboxDefaultTypes = {
  agent: null,
  header: 'Recent Transactions',
  loading: false,
  view: null,
  canSendWebhookFromPage: false,
  canUpdateStatus: false,
  caseToken: null,
};

const TransactionHistoryCollapsibox = ({
  loading,
  header,
  agent,
  entity,
  view,
  canSendWebhookFromPage,
  canUpdateStatus,
  caseToken,
}) => {
  const [inPrintMode, setInPrintMode] = useState(false);
  const [hasTransactions, setHasTransactions] = useState(true);
  const { featureFlags } = useContext(UserContext);
  const hideEmptyCardsPesEnabled = Boolean(featureFlags?.removeEmptyCardsPes);

  const transactionColumns = {
    priority_columns: [...DEFAULT_COLUMNS.priority],
    secondary_columns: [...DEFAULT_COLUMNS.secondary],
  };

  useEffect(() => {
    const handlerBeforePrint = () => setInPrintMode(true);
    const handlerAfterPrint = () => setInPrintMode(false);
    window.addEventListener('beforeprint', handlerBeforePrint);
    window.addEventListener('afterprint', handlerAfterPrint);
  }, []);

  const handleTransactionsLoad = useCallback(loaded => {
    setHasTransactions(loaded);
  }, []);

  if (!shouldRenderCard(hasTransactions, hideEmptyCardsPesEnabled)) {
    return null;
  }

  return (
    <CollapsiboxWrapper>
      <CollapsiboxTransactionHistory
        header={header}
        {...(inPrintMode ? { collapsed: false } : {})}
      >
        <SnackBarProvider>
          <TransactionHistory
            hasEvidenceModal
            transactionColumns={transactionColumns}
            loading={loading}
            agent={agent}
            entity={entity}
            view={view}
            isActionable
            canSendWebhookFromPage={canSendWebhookFromPage}
            canUpdateStatus={canUpdateStatus}
            caseToken={caseToken}
            onLoad={handleTransactionsLoad}
          />
        </SnackBarProvider>
      </CollapsiboxTransactionHistory>
    </CollapsiboxWrapper>
  );
};

TransactionHistoryCollapsibox.propTypes = TransactionHistoryCollapsiboxPropTypes;
TransactionHistoryCollapsibox.defaultProps = TransactionHistoryCollapsiboxDefaultTypes;

export default TransactionHistoryCollapsibox;
